import React from "react";
import "./demo-class.css";
import ObjectImg from "../assets/object_img.png";

const DemoClass = () => {
  return (
    <div>
      <section className="demo-section">
        <div className="demo-wrapper">
          <div className="demo-content">
            <div className="demo-heading-group">
              <h1 className="demo-title">
                Interactive Learning : Try Our
                <span style={{ color: "rgba(43, 147, 165, 1)" }}> Online Demo Classes</span>
              </h1>
              <p className="demo-subtitle">
                Join us for a demo class to understand our commitment to excellence in one‑on‑one online tutoring.
              </p>
            </div>
            <button
              type="button"
              className="demo-button"
              onClick={() => {
                const el = document.getElementById("find-a-tutor-form");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }}>
              <span>Book a free demo</span>
            </button>
          </div>
          <div className="demo-visual">
            {/* Replace with your exported demo class illustration */}
            <img src={ObjectImg} alt="Demo class illustration" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default DemoClass;
